import { faEmptySet } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useI18n } from 'hooks/useI18n';
import { StyledEmpty, StyledEmptyTitle } from './HPCComparison.styled';

const HPCEmpty: React.FC = () => {
  const { t } = useI18n('hiring-process-comparison');

  return (
    <StyledEmpty>
      <FontAwesomeIcon icon={faEmptySet} />
      <StyledEmptyTitle>
        {t('hiring-process-comparison.process_comparison.empty_title')}
      </StyledEmptyTitle>
      <p>{t('hiring-process-comparison.process_comparison.empty_desc')}</p>
    </StyledEmpty>
  );
};

export default HPCEmpty;
